import { Fragment } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Mui
import { Box, Tooltip } from '@mui/material';
// Components
import { Button } from 'app/components/Mui';
import Icon from '../Icon';
// ToDO
import { IPage } from '@root/models/Page';
import { selectPage } from 'app/store/page/page.selectors';
import useMenu from 'app/hooks/useMenu';
import { usePageEpisodesContext } from 'app/context/PageEpisodes.context';
// End: ToDO

const SortByButton = () => {
  const { t } = useTranslation();
  // State
  // ToDO
  const page = useAppSelector((state) => selectPage(state as any)) as IPage;
  // End: ToDO

  const { Menu, MenuItem, openMenu } = useMenu();

  const { sortBy, setSortBy, episodes, isPageRoute } = usePageEpisodesContext();

  const handleClick = (newSortBy:string) => () => {
    setSortBy(newSortBy);
  }

  if (!page || (episodes.length < 2)) return null;
  if (!isPageRoute && (!page.staple || page.staple.order !== 1)) return null;
  return (
    <Fragment>
      <Tooltip title={t('labels.sort')}>
        <div>
          <Button
            name="Sort by"
            sx={{ gap: 1, textTransform: 'capitalize' }}
            onClick={openMenu}
            size="small"
            variant="outlined"
          >
            <Icon
              icon="sort-amount-desc"
              rootSx={{ p: 0.5 }}
              sx={{ width: '16px', height: '16px', fontSize: '16px', transform: 'rotateX(180deg)' }}
            />
            <Box component="span" sx={{ lineHeight: 1 }}>{sortBy === 'date' ? 'Date' : 'Page'}</Box>
          </Button>
        </div>
      </Tooltip>
      <Menu>
        <MenuItem name="Sort by date" onClick={handleClick('date')}>Sort by date</MenuItem>
        <MenuItem name="Sort by page" onClick={handleClick('pageNum')}>Sort by page</MenuItem>
      </Menu>
    </Fragment>
  )
}

export default SortByButton;
